module.exports = __webpack_public_path__ + "static/media/sala_principal_2.89a6d33a.jpg";